module.exports = __webpack_public_path__ + "img/04.763960c4.png";